// Function to format file size from KB to MB if necessary
export const formatFileSizeDisplay = (value) => {
    if (value < 1024) {
        return `${value} KB`;
    }
    return `${parseFloat((value / 1024).toFixed(1))} MB`;
};

// Function to calculate total experience in years and months
export const calculateExperience = (startDate) => {
  const start = new Date(startDate);
  const today = new Date();

  let years = today.getFullYear() - start.getFullYear();
  let months = today.getMonth() - start.getMonth();
  
  if (months < 0) {
    years--;
    months += 12;
  }

  const totalExperience = years + months / 12;

  // Round to nearest 0.5
  return Math.round(totalExperience * 2) / 2;
}
